import { FamilyMember, PersonalInfo } from '@/types';

// Generate 10 generations of family members
export const demoMembers: FamilyMember[] = [
  // First Generation (Root)
  {
    id: 'gen1',
    name: 'عبدالله العمري',
    children: ['gen2'],
  },
  // Second Generation
  {
    id: 'gen2',
    name: 'محمد بن عبدالله',
    parentId: 'gen1',
    children: ['gen3'],
  },
  // Third Generation
  {
    id: 'gen3',
    name: 'أحمد بن محمد',
    parentId: 'gen2',
    children: ['gen4'],
  },
  // Fourth Generation
  {
    id: 'gen4',
    name: 'عبدالرحمن بن أحمد',
    parentId: 'gen3',
    children: ['gen5'],
  },
  // Fifth Generation
  {
    id: 'gen5',
    name: 'خالد بن عبدالرحمن',
    parentId: 'gen4',
    children: ['gen6'],
  },
  // Sixth Generation
  {
    id: 'gen6',
    name: 'فهد بن خالد',
    parentId: 'gen5',
    children: ['gen7'],
  },
  // Seventh Generation
  {
    id: 'gen7',
    name: 'سلطان بن فهد',
    parentId: 'gen6',
    children: ['gen8'],
  },
  // Eighth Generation
  {
    id: 'gen8',
    name: 'عمر بن سلطان',
    parentId: 'gen7',
    children: ['gen9'],
  },
  // Ninth Generation
  {
    id: 'gen9',
    name: 'يوسف بن عمر',
    parentId: 'gen8',
    children: ['gen10'],
  },
  // Tenth Generation (Last)
  {
    id: 'gen10',
    name: 'عبدالعزيز بن يوسف',
    parentId: 'gen9',
    children: [],
  },
];

// Add some personal info for demo
export const demoPersonalInfo: PersonalInfo[] = [
  {
    id: 'info1',
    fullName: 'عبدالله محمد العمري',
    description: 'مؤسس العائلة وكبير أفرادها',
    photoUrl: 'https://images.unsplash.com/photo-1553867745-6e038d085e86?w=400&h=400&fit=crop',
    isResumePublic: false,
    createdAt: Date.now(),
    updatedAt: Date.now(),
  },
  {
    id: 'info2',
    fullName: 'محمد بن عبدالله العمري',
    description: 'من رواد التعليم في المنطقة',
    photoUrl: 'https://images.unsplash.com/photo-1566753323558-f4e0952af115?w=400&h=400&fit=crop',
    isResumePublic: false,
    createdAt: Date.now(),
    updatedAt: Date.now(),
  },
  {
    id: 'info3',
    fullName: 'عبدالعزيز بن يوسف العمري',
    description: 'مهندس برمجيات في شركة عالمية',
    photoUrl: 'https://images.unsplash.com/photo-1600486913747-55e5470d6f40?w=400&h=400&fit=crop',
    isResumePublic: false,
    createdAt: Date.now(),
    updatedAt: Date.now(),
  },
];